import { render, staticRenderFns } from "./solicitar-transferencia.vue?vue&type=template&id=6f98de72&"
import script from "./solicitar-transferencia.vue?vue&type=script&lang=js&"
export * from "./solicitar-transferencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports